import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  LoaderContainer,
  DoughnutLoader,
  ProgressRing,
  ProgressRingCircle,
  ProgressBar,
  LoadingText,
} from "./LoaderStyles";

const Loader = () => {
  const loading = useSelector((state) => state.loader.loading);
  const [progress, setProgress] = useState(0);
  const [dots, setDots] = useState("");
  const strokeDashArray = "251.2"; // Circumference of the circle
  const strokeDashOffset =
    ((100 - progress) / 100) * parseFloat(strokeDashArray);

  useEffect(() => {
    if (loading) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress < 95 ? prevProgress + 1 : 98
        );
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [loading]);

  useEffect(() => {
    if (loading) {
      const dotInterval = setInterval(() => {
        setDots((prevDots) => (prevDots === "..." ? "" : prevDots + "."));
      }, 500);
      return () => clearInterval(dotInterval);
    }
  }, [loading]);

  return (
    <LoaderContainer loading={loading}>
      <DoughnutLoader>
        <ProgressRing viewBox="0 0 100 100">
          <ProgressRingCircle cx="50" cy="50" r="40" />
          <ProgressBar
            cx="50"
            cy="50"
            r="40"
            style={{
              strokeDasharray: strokeDashArray,
              strokeDashoffset: strokeDashOffset,
            }}
          />
          <text
            x="50"
            y="50"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="black"
          >
            {progress}%
          </text>
        </ProgressRing>
        <LoadingText>Processing{dots}</LoadingText>
      </DoughnutLoader>
    </LoaderContainer>
  );
};

export default Loader;
